export default __webpack_public_path__ + "static/media/up.48e7e239.svg";